import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Field } from 'redux-form'

import { get } from 'lodash'

import { translate } from 'parking-react-common'

import { api, ui, routing, forms } from '../redux'

import form from '../components/Form'
import Panel from '../components/Panel'
import { Row, Column } from '../components/Grid'
import Input from '../components/Input'
import Button from '../components/Button'

const AccountSettingsForm = ({ currentValues, isSubmitting, isPristine, dispatch, cancelButtonRoute, t }) => (
    <Column span={ 8 }>
        <Panel title={ t('Account Settings') }>
            <Field
                name="first_name"
                placeholder={ t('First Name') }
                label={ t('First Name') }
                component={ Input }
            />
            <Field
                name="last_name"
                placeholder={ t('Last Name') }
                label={ t('Last Name') }
                component={ Input }
            />
            <Field
                name="email"
                placeholder={ t('Email Address') }
                label={ t('Email Address') }
                component={ Input }
                description={
                    currentValues.has_verified_email
                        ? t('The address has been verified.')
                        : t('The address has not yet been verified.')
                }
            />
            <Row>
                <Column span={ 6 }>
                    <Button
                        type="submit"
                        label={ t('Save') }
                        size={ ui.SIZE.large }
                        intent={ ui.INTENT.primary }
                        isBlock
                        disabled={ isSubmitting || isPristine }
                    />
                </Column>
                <Column span={ 6 }>
                    <Button
                        label={ t('Cancel') }
                        size={ ui.SIZE.large }
                        link={ routing.routeFor(cancelButtonRoute) }
                        isBlock
                    />
                </Column>
            </Row>
        </Panel>
        <Panel title={ t('Delete Account') }>
            <p>{ t('The account will be deleted forever from our server. This action is not undoable.') }</p>
            <Button
                label={ t('Delete Account') }
                size={ ui.SIZE.large }
                intent={ ui.INTENT.danger }
                onClick={ () => {
                    // eslint-disable-next-line no-alert
                    if (window.confirm(t('Are you sure you want to delete the account?'))) {
                        dispatch(api.destroy(currentValues.url))
                    }
                } }
            />
        </Panel>
    </Column>
)

AccountSettingsForm.propTypes = forms.propTypes

function mapStateToProps(state) {
    const currentRoute = routing.getCurrentRoute(state)
    const cancelButtonRoute = get(currentRoute, 'key') === 'users' ? 'users' : 'dashboard'

    return {
        cancelButtonRoute
    }
}

export default compose(
    translate(),
    form({ id: forms.profile.id }),
    connect(mapStateToProps),
)(AccountSettingsForm)
